import React, { useState, useEffect, useRef } from 'react';
import '../../../assets/css/MakeupGallery.css';

const IMAGES = [
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915153/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_5_sumwyf.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915154/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_1_wvttrt.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915156/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_4_wp0mzx.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915158/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_6_quxznk.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915158/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_8_t5jpte.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915163/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_3_jncgzx.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915179/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_2_gmgusl.png",
  "https://res.cloudinary.com/dxa2jevmo/image/upload/v1779915181/Brown_Minimalist_Skincare_Before_After_Collage_Instagram_Post_hpfdiq.png",
];

export default function VegaGallery() {
  const [visible, setVisible] = useState(false);
  const [lb, setLb] = useState({ open: false, index: 0, dir: 'next', closing: false });

  const sectionRef = useRef(null);
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);
  const returnFocusRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!lb.open || lb.closing) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape')     closeLb();
      if (e.key === 'ArrowRight') nav(1);
      if (e.key === 'ArrowLeft')  nav(-1);
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [lb.open, lb.closing]); // eslint-disable-line react-hooks/exhaustive-deps

  const openLb = (trigger) => {
    returnFocusRef.current = trigger;
    setLb({ open: true, index: 0, dir: 'next', closing: false });
  };

  const closeLb = () => {
    setLb(prev => ({ ...prev, closing: true }));
    setTimeout(() => {
      setLb({ open: false, index: 0, dir: 'next', closing: false });
      returnFocusRef.current?.focus();
    }, 280);
  };

  const nav = (delta) => {
    setLb(prev => ({
      ...prev,
      index: (prev.index + delta + IMAGES.length) % IMAGES.length,
      dir: delta > 0 ? 'next' : 'prev',
    }));
  };

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };

  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    const dy = e.changedTouches[0].clientY - touchStartY.current;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 44) nav(dx < 0 ? 1 : -1);
    touchStartX.current = null;
    touchStartY.current = null;
  };

  return (
    <>
      <div
        ref={sectionRef}
        className={`mgs-section${visible ? ' mgs-section--in' : ''}`}
      >
        <button
          className="mgs-stack"
          type="button"
          onClick={(e) => openLb(e.currentTarget)}
          aria-label={`Otvori galeriju Vega obrva - ${IMAGES.length} fotografija`}
        >
          <div className="mgs-card mgs-card--back" aria-hidden="true">
            <img src={IMAGES[2]} alt="" width="1080" height="1080" loading="lazy" draggable={false} />
          </div>

          <div className="mgs-card mgs-card--mid" aria-hidden="true">
            <img src={IMAGES[1]} alt="" width="1080" height="1080" loading="lazy" draggable={false} />
          </div>

          <div className="mgs-card mgs-card--front" aria-hidden="true">
            <img src={IMAGES[0]} alt="Vega obrve" width="1080" height="1080" loading="eager" draggable={false} />
            <div className="mgs-badge">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" aria-hidden="true">
                <rect x="0"   y="0"   width="4" height="4" rx="0.8"/>
                <rect x="6"   y="0"   width="4" height="4" rx="0.8"/>
                <rect x="0"   y="6"   width="4" height="4" rx="0.8"/>
                <rect x="6"   y="6"   width="4" height="4" rx="0.8"/>
              </svg>
              {IMAGES.length} fotografija
            </div>
          </div>
        </button>

        <button
          type="button"
          className="mgs-hint"
          onClick={(e) => openLb(e.currentTarget)}
          tabIndex={-1}
          aria-hidden="true"
        >
          Pogledaj galeriju
          <svg width="13" height="10" viewBox="0 0 13 10" fill="none" stroke="currentColor"
               strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <line x1="0" y1="5" x2="11" y2="5"/>
            <polyline points="7.5,1.5 11,5 7.5,8.5"/>
          </svg>
        </button>
      </div>

      {lb.open && (
        <div
          className={`mg-lb${lb.closing ? ' mg-lb--out' : ''}`}
          onClick={(e) => e.target === e.currentTarget && closeLb()}
          role="dialog"
          aria-modal="true"
          aria-label={`Slika ${lb.index + 1} od ${IMAGES.length}`}
        >
          <button className="mg-lb-close" type="button" onClick={closeLb} aria-label="Zatvori galeriju">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor"
                 strokeWidth="1.6" strokeLinecap="round">
              <line x1="1" y1="1" x2="14" y2="14"/>
              <line x1="14" y1="1" x2="1" y2="14"/>
            </svg>
          </button>

          <button className="mg-lb-btn mg-lb-prev" type="button" onClick={() => nav(-1)} aria-label="Prethodna slika">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor"
                 strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9.5,2 3,7.5 9.5,13"/>
            </svg>
          </button>

          <div className="mg-lb-stage" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
            <img
              key={lb.index}
              src={IMAGES[lb.index]}
              alt={`Vega obrve ${lb.index + 1}`}
              className={`mg-lb-img mg-lb-img--${lb.dir}`}
              draggable={false}
            />
          </div>

          <button className="mg-lb-btn mg-lb-next" type="button" onClick={() => nav(1)} aria-label="Sledeća slika">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor"
                 strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="5.5,2 12,7.5 5.5,13"/>
            </svg>
          </button>

          <div className="mg-lb-footer">
            <div className="mg-lb-dots" role="tablist" aria-label="Navigacija kroz slike">
              {IMAGES.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  role="tab"
                  aria-selected={i === lb.index}
                  aria-label={`Slika ${i + 1}`}
                  className={`mg-lb-dot${i === lb.index ? ' mg-lb-dot--on' : ''}`}
                  onClick={() => setLb(prev => ({
                    ...prev,
                    index: i,
                    dir: i > prev.index ? 'next' : 'prev',
                  }))}
                />
              ))}
            </div>
            <span className="mg-lb-count" aria-live="polite">
              {lb.index + 1} / {IMAGES.length}
            </span>
          </div>
        </div>
      )}
    </>
  );
}
